import 'css-chunksrc/client/pages/calendarPage/sideBar/styles.scss';export default {
  "sideBar": "_sideBar_1bvjw_1",
  "title": "_title_1bvjw_13",
  "projects": "_projects_1bvjw_21",
  "legends": "_legends_1bvjw_28",
  "legendHolidays": "_legendHolidays_1bvjw_44",
  "legendWeekends": "_legendWeekends_1bvjw_52",
  "legendUnavailability": "_legendUnavailability_1bvjw_60",
  "footer": "_footer_1bvjw_68",
  "exportButton": "_exportButton_1bvjw_73",
  "exportLink": "_exportLink_1bvjw_79",
  "link": "_link_1bvjw_91",
  "copyButton": "_copyButton_1bvjw_100",
  "copyIcon": "_copyIcon_1bvjw_109"
};